import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';
import { StoreBadges } from './StoreCTA';
import { useClientDate } from '../utils/useClientDate';
import { useAccount } from '../account/AccountContext.jsx';

function Footer() {
  const { pathname } = useLocation();
  const year = useClientDate().getFullYear();
  const { user } = useAccount();
  const openConsentPreferences = () => {
    window.dispatchEvent(new Event('openConsentPreferences'));
  };

  return (
    <footer className="footer">
      <div className="container footer-content">
        <div className="footer-section">
          <Link to="/" className="footer-brand">
            <img src="/brand/mark.png" alt="" width="36" height="36" loading="lazy" />
            <span>Logic Puzzles</span>
          </Link>
          <p className="footer-text">Free, fair, beautifully made logic puzzles. Made in Canada by <a href="https://sparkandspiral.ca" target="_blank" rel="noopener">Spark &amp; Spiral</a>.</p>
          <p className="footer-text footer-app-label">Get the free Crowns puzzle app:</p>
          <div className="footer-store-badges">
            <StoreBadges app="crowns" placement="footer" page={pathname} />
          </div>
          <div className="social-links">
            <a 
              href="https://www.instagram.com/sparkandspiralsoftware" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-link"
              aria-label="Follow us on Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a 
              href="https://www.tiktok.com/@sparkandspiralsoftware" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-link"
              aria-label="Follow us on TikTok"
            >
              <i className="fab fa-tiktok"></i>
            </a>
            <a 
              href="https://www.youtube.com/@sparkandspiralsoftware" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-link"
              aria-label="Subscribe to our YouTube channel"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a 
              href="https://discord.gg/Vh27jjmMBS" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-link"
              aria-label="Join our Discord server"
            >
              <i className="fab fa-discord"></i>
            </a>
          </div>
        </div>
        <div className="footer-section">
          <h3>Popular Puzzles</h3>
          <ul>
            <li><Link to="/crowns-puzzle">Crowns (Daily + Unlimited)</Link></li>
            <li><Link to="/games/sudoku">Sudoku</Link></li>
            <li><Link to="/games/nonograms">Nonograms</Link></li>
            <li><Link to="/games/calcudoku">Calcudoku</Link></li>
            <li><Link to="/games/mine-finder">Mine Finder</Link></li>
            <li><Link to="/games/logic-grid-puzzles">Logic Grid Puzzles</Link></li>
            <li><Link to="/games/cryptograms">Cryptograms</Link></li>
            <li><Link to="/games/tent-logic">Tent Logic</Link></li>
            <li><Link to="/games/futoshiki">Futoshiki</Link></li>
            <li><Link to="/printable">Printable Puzzles</Link></li>
            <li><Link to="/teachers-and-libraries">Teachers &amp; Libraries</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/logic-games">Logic Games</Link></li>
            <li><Link to="/word-games">Word Games</Link></li>
            <li><Link to="/card-games">Card Games</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/press">Press</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/account">{user ? 'Your account' : 'Sign in'}</Link></li>
            <li><Link to="/plus">Spark &amp; Spiral Plus</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Legal</h3>
          <ul>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-of-service">Terms of Service</Link></li>
            <li><Link to="/refund-policy">Refund Policy</Link></li>
            <li><Link to="/account/delete">Delete account</Link></li>
            <li>
              <button type="button" className="consent-link" onClick={openConsentPreferences}>
                Manage Consent
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p className="copyright-text">&copy; {year} Spark and Spiral Software Inc. All rights reserved.</p>
          <p className="copyright-text">Every puzzle solvable by logic alone.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 